// Port of api/fuel/app/classes/model/listing/comment.php
import Model from 'offline/stream/model/base'

export default Model.extend({
	table: 'list_comment',
	prefix: '',
	key: 'list_comment_id',
	fields: {
		list_comment_id: Model.SCHEMA_NUMBER,
		list_id: Model.SCHEMA_NUMBER,
		list_edition_id: Model.SCHEMA_NUMBER,
		game_id: Model.SCHEMA_NUMBER,
		list_comment_date: Model.SCHEMA_DATE_SAVE,
		list_comment_text: Model.SCHEMA_TEXT
	}
})
